/**
 * exatrek REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: v3
 * Contact: dev@exatrek.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface JobTimeV2Dto {
  accounting1Val?: number;
  accounting2Val?: number;
  accounting3Val?: number;
  accounting4Val?: number;
  accounting5Val?: number;
  duration?: number;
  employeeCost?: number;
  firedUp?: boolean;
  fuelConsumed?: number;
  fuelCost?: number;
  ha?: number;
  id?: number;
  idleDuration?: number;
  jobId?: number;
  km?: number;
  machineCost?: number;
  primaryImplementCost?: number;
  secondaryImplementCost?: number;
  start?: string;
  stop?: string;
  workstate?: string;
}
